export default {
  string: () => import("./String")
};
